<template>
    <div class="login-wrap">
        <Modal v-show="is_show_modal" @close="close">
            <form class="form-wrap" role="form" v-if="type === 'login'">
                <h2 class="form-title">Login</h2>
                <div class="form-row">
                    <input type="text" required="required" class="input-text" name="username" id="username" value="" placeholder="Username/Email" v-model="login_form.username">
                </div>
                <div class="form-row">
                    <input class="input-text" minlength="6" required="required" type="password" name="password" id="password" placeholder="Password" v-model="login_form.password">
                </div>
                <div class="error-msg" v-if="error_msg" v-html="error_msg"></div>
                <div class="success-msg" v-if="success_msg" v-html="success_msg"></div>
                <div class="form-submit">
                    <Button class="btn-login" @click.native="login">Login</Button>
                </div>
                <div class="bottom-links">
                    <span @click="change('sign_up')">Sign up</span>
                    <span @click="change('lost_password')">Lost your password?</span>
                </div>
            </form>
            <form class="form-wrap" role="form" v-if="type === 'sign_up'">
                <h2 class="form-title">Sign up</h2>
                <div class="form-row">
                    <input type="email" placeholder="Email" required="required" v-model="register_form.email">
                </div>
                <div class="form-row">
                    <input type="text" placeholder="Name" required="required" v-model="register_form.username">
                </div>
                <div class="form-row">
                    <input type="password" placeholder="Password" minlength="6" required="required" v-model="register_form.password">
                </div>
                <div class="form-row">
                    <input type="password" placeholder="Confirm Password" minlength="6" required="required" v-model="register_form.confirm_password">
                </div>
                <div class="error-msg" v-if="error_msg" v-html="error_msg"></div>
                <div class="success-msg" v-if="success_msg" v-html="success_msg"></div>
                <div class="form-submit">
                    <Button class="btn-login" @click.native="register">Register</Button>
                </div>
                <div class="bottom-links">
                    <span @click="change('login')">Login</span>
                    <span @click="change('lost_password')">Lost your password?</span>
                </div>
            </form>
            <form class="form-wrap" role="form" v-if="type === 'lost_password'">
                <h2 class="form-title">Lost password</h2>
                <div class="form-row">
                    <input type="text" name="user_login" autocomplete="username" placeholder="Username or email" v-model="lost_password_form.username">
                    <p>Lost your password? Please enter your username or email address. You will receive a link to create a new password via email.</p>
                </div>
                <div class="error-msg" v-if="error_msg" v-html="error_msg"></div>
                <div class="success-msg" v-if="success_msg" v-html="success_msg"></div>

                <div class="form-submit">
                    <Button class="btn-login" @click.native="reset">Reset password</Button>
                </div>
                <div class="bottom-links">
                    <span @click="change('login')">Login</span>
                    <span @click="change('sign_up')">Sign up</span>
                </div>
            </form>

            <Loading  v-if="is_loading" class="absolute" />
        </Modal>
    </div>
</template>

<script>
// import '@/assets/svg/close.svg?sprite';

import Link from '@/components/ui/Link.vue';
import Loading from '@/components/Loading.vue';
import Modal from '@/components/ui/Modal.vue';
import Button from '@/components/ui/Button.vue';

import { EventBus } from '@/events/bus.js';

export default {
    name: 'mini-cart',

    data() {
        return {
            is_loading: false,
            type: 'login',
            is_show_modal: false,
            login_form: {
                username: '',
                password: '',
            },
            register_form: {
                username: '',
                password: '',
                confirm_password: '',
                email: '',
            },
            lost_password_form: {
                username: '',
            },
            error_msg: '',
            success_msg: '',
        }
    },

    components: {
        Link,
        Loading,
        Button,
        Modal,
    },

    methods: {
        close() {
            this.is_show_modal = false;
        },

        open() {
            this.is_show_modal = true;
            // this.type = 'login';
            this.error_msg = '';
            this.success_msg = '';
        },

        change(type) {
            this.type = type;
            this.error_msg = '';
            this.success_msg = '';
        },

        login() {
            this.error_msg = '';
            this.success_msg = '';

            if (!this.login_form.username) {
                this.error_msg += `<p>The username or email is required</p>`;
            }

            if (!this.login_form.password) {
                this.error_msg += `<p>The password is required</p>`;
            }

            if (this.login_form.password.length < 6) {
                this.error_msg += `<p>The password must be greater than 6 digits</p>`;
            }


            if (this.error_msg !== '') return;
            
            this.is_loading = true;
            let form_data = new FormData;
            form_data.append('password', this.login_form.password);
            form_data.append('username', this.login_form.username);
            this.$ajax.post('login', form_data).then((response) => {
                if (response.data.loggedin) {
                    this.error_msg = '';
                    this.success_msg = `<p>${response.data.message}</p>`;

                    setTimeout(() => {
                        window.location.reload();
                    }, 1500);
                } else {
                    this.error_msg += `<p>${response.data.message}</p>`;
                }
                this.is_loading = false;
            });


        },

        register() {
            const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

            this.error_msg = '';
            this.success_msg = '';

            if (!this.register_form.username) {
                this.error_msg += `<p>The username is required</p>`;
            }

            if (!this.register_form.email) {
                this.error_msg += `<p>The email is required</p>`;
            }

            else if (!re.test(String(this.register_form.email).toLowerCase())) {
                this.error_msg += `<p>The email "${this.register_form.email}" is not valid</p>`;
            }

            if (!this.register_form.password) {
                this.error_msg += `<p>The password is required</p>`;
            }

            if (this.register_form.password.length < 6) {
                this.error_msg += `<p>The password must be greater than 6 digits</p>`;
            }
            
            if (this.register_form.password != this.register_form.confirm_password) {
                this.error_msg += `<p>Your password and confirmation password do not match.</p>`;
            }

            if (this.error_msg !== '') return;

            this.is_loading = true;


            let form_data = new FormData;
            form_data.append('password', this.register_form.password);
            form_data.append('username', this.register_form.username);
            form_data.append('email', this.register_form.email);
            this.$ajax.post('register', form_data).then((response) => {
                if (response.data.loggedin) {
                    this.error_msg = '';
                    this.success_msg = `<p>${response.data.message}</p>`;

                    setTimeout(() => {
                        window.location.reload();
                    }, 5000);
                } else {
                    this.error_msg += `<p>${response.data.message}</p>`;
                }
                this.is_loading = false;

            });

        },

        reset() {
            this.error_msg = '';
            this.success_msg = '';

            if (!this.lost_password_form.username) {
                this.error_msg += `<p>The username or email is required</p>`;
            }

            if (this.error_msg !== '') return;
            
            this.is_loading = true;

            let form_data = new FormData;
            form_data.append('username', this.lost_password_form.username);

            this.$ajax.post('lost-password', form_data).then((response) => {
                if (response.data.loggedin) {
                    this.error_msg = '';
                    this.success_msg = `<p>${response.data.message}</p>`;

                    setTimeout(() => {
                        this.close();
                    }, 1500);
                } else {
                    this.error_msg += `<p>${response.data.message}</p>`;
                }
                this.is_loading = false;

            });


        },
    },


    mounted() {
        EventBus.$on('login.close', () => {
            this.close();
        });

        EventBus.$on('login.open', () => {
            this.change('login');
            this.open();
        });

        EventBus.$on('signup.open', () => {
            this.change('sign_up');
            this.open();
        });
    },
}

</script>
<style lang="scss">
.login-wrap {

    .form-wrap {
        width: 38rem;
    }
    
    .form-title {
        text-align: center;
        margin: 0 0 var(--padding-x2);
        font-size: var(--medium-size);
    }

    .form-row {
        margin: var(--padding) 0;
        
        input {
            padding: 1.25rem 1rem;
            border: none;
            width: 100%;
            box-sizing: border-box;
            font-size: var(--small-size);

            & + p {
                font-size: var(--small-size);
                margin: .75rem;
                text-align: center;
            }
        }
    }

    .form-submit {
        text-align: center;
        margin: var(--padding-x2) 0;

        .ui-button {
            margin: 0 1rem;
        }
    }

    .bottom-links {
        position: absolute;
        right: var(--padding);
        bottom: var(--padding);
        font-size: var(--small-size);

        span {
            cursor: pointer;
            
            &:first-child::after {
                content: '|';
                padding: 0 var(--padding);
            }
        }
    }

    .error-msg {
        position: relative;
        margin: -.75rem 0 0;
        font-size: var(--small-size);
        color: red;
    }

    .success-msg {
        position: relative;
        margin: -.75rem 0 0;
        font-size: var(--small-size);
        color: rgb(137, 221, 137);
    }


    .loading-wrap.absolute {
        height: 100%;
        width: 100%;
        z-index: 999;
        background: rgba(#fff, 0.5);
        pointer-events: unset;

        .lds-spinner {
            transform: translate(-50%, -50%);
        }
    }
}
</style>